export const interactiveExhibitions = [
  {
    id: 'pesta-riang-nusantara',
    order: '03',
    tag: '3rd Installation · Current',
    name: 'Pesta Riang Nusantara',
    subtitle: 'A Radiant of Nusantara Festival.',
    role: 'Cultural Interactive Installation',
    mainImage: 'kin/assest/about/kininteractive/pestariang1.webp',
    accentColor: '#C4614E',
    description: `A Radiant of Nusantara Festival is an interactive installation exhibition that highlights Indonesia's Intangible Cultural Heritage through immersive and participatory experiences. By presenting replicas of traditional snacks, games, and musical instruments from across the archipelago, the exhibition invites children and families to experience culture as something living and tangible.

Within the exhibition space, children can hug and explore Nusantara snacks while learning to map them to their regions of origin. They can play a giant dakon, enjoy the festive atmosphere of a Balinese kite festival that teaches togetherness and social values, and explore sounds through a variety of traditional musical instruments.

This exhibition becomes both a playground and a learning space, where children are invited to celebrate the joy of childhood while discovering, appreciating, and preserving the rich cultural diversity of the Nusantara.`,
    tags: ['Culture', 'Heritage', 'Hands-on', 'Festive'],
    images: [
      'kin/assest/about/kininteractive/pestariang1.webp',
      'kin/assest/about/kininteractive/pestariang2.webp',
      'kin/assest/about/kininteractive/pestariang3.webp',
    ],
    videoId: null,
  },
  {
    id: 'canvas-of-future',
    order: '02',
    tag: '2nd Installation',
    name: 'Canvas Of Future',
    subtitle: 'Children as the architects of tomorrow.',
    role: 'Interactive Installation',
    mainImage: 'kin/assest/about/kininteractive/canva-1.webp',
    accentColor: '#F58136',
    description: `Canvas of the Future is an interactive installation that presents a participatory space for children as young future planners.

This installation encourages children to express their ideas and perspectives on Indonesia's future through creative and exploratory approaches. Through a variety of artistic activities—such as drawing, coloring, stamping, collage, and assembling—children are invited to explore themes related to nation-building, including infrastructure, well-being, education, healthcare, and environmental sustainability.

These creative processes serve as a reflective medium through which children can articulate their ideas, hopes, and the values they consider important. This installation opens a space for intergenerational dialogue and emphasizes that the future can be imagined and shaped from an early age through the imagination and creativity of the next generation.`,
    tags: ['Creativity', 'Education', 'Future', 'Hands-on'],
    images: [
      'kin/assest/about/kininteractive/canva-1.webp',
      'kin/assest/about/kininteractive/canva-2.webp',
      'kin/assest/about/kininteractive/canva-3.webp',
    ],
    videoId: null,
  },
  {
    id: 'jelajah-nusantara',
    order: '01',
    tag: '1st Installation',
    name: 'Jelajah Nusantara',
    subtitle: 'Rediscovering the Heart of Nusantara.',
    role: 'Cultural Installation',
    mainImage: 'kin/assest/about/kininteractive/nusantara-1.webp',
    accentColor: '#73C8AF',
    description: `Jelajah Nusantara offers an immersive experience that invites visitors to rediscover the meaning of the village—as a home, a place to grow, and a source of life.

Inspired by the song Desaku yang Kucinta by Liberty Manik, this installation reflects a longing for one's homeland—a landscape rich in natural beauty and abundant resources. In KiNTERACTIVE, visitors are invited to participate in farming and gardening activities, pretending to be farmers who care for the land and enjoy its harvest.

Through this journey, visitors are encouraged to rediscover the charm of the village as an essential part of Nusantara's cultural identity.`,
    tags: ['Culture', 'Nature', 'Hands-on', 'Exploration'],
    images: [
      'kin/assest/about/kininteractive/nusantara-1.webp',
      'kin/assest/about/kininteractive/nusantara-2.webp',
      'kin/assest/about/kininteractive/nusantara-3.webp',
    ],
    videoId: null,
  },
];
